import React from 'react';
import Logo from '../../Basic/Icons/Logo/Logo.mjs';
import HorizontalList from '../../Basic/Lists/HorizontalList/HorizontalList.mjs';
import DesktopOnly from '../../Containers/DesktopOnly/DesktopOnly.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import MobileOnly from '../../Containers/MobileOnly/MobileOnly.mjs';
import { StyledNavigation } from './SimpleNavigation.styles.mjs';
import { useTheme } from 'styled-components';

const TopNavigation = ({ menuItems, homeUrl, regionName, onClick }) => {
    const theme = useTheme();
    const menuListJsx = React.createElement(HorizontalList, { options: menuItems, onClick: onClick });
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledNavigation, null,
            React.createElement(FlexContainer, null,
                React.createElement("a", { href: homeUrl },
                    React.createElement(Logo, { region: regionName }))),
            React.createElement(DesktopOnly, { breakpoint: theme.breakpoints.xl }, menuListJsx)),
        React.createElement(MobileOnly, { breakpoint: theme.breakpoints.xl }, menuListJsx)));
};

export { TopNavigation as default };
//# sourceMappingURL=SimpleNavigation.mjs.map
